import { getFileUrl, deleteFile, getUploadEndpoint } from '@modules/fileHelpers'

export const mapFiles = (files, employeeId) => files?.map(file => ({
  id: file.id,
  name: file.fileName,
  size: file.size,
  url: () => getFileUrl(file, employeeId),
  preview: () => getFileUrl(file, employeeId)
}))

export { getFileUrl, deleteFile, getUploadEndpoint }
